import axios from 'axios';

const API_BASE = '/api/scout';

export const scoutService = {
  async send(data: { athleteUuid: string; subject: string; message: string }): Promise<{ threadId: string }> {
    const res = await axios.post(`${API_BASE}/send.php`, data);
    return res.data.data;
  },

  async list(role: 'athlete' | 'company'): Promise<any[]> {
    const res = await axios.get(`${API_BASE}/list.php?role=${role}`);
    return res.data.data;
  },

  async getThread(threadId: string): Promise<{ thread: any; messages: any[] }> {
    const res = await axios.get(`${API_BASE}/thread.php?threadId=${threadId}`);
    return res.data.data;
  },

  async reply(threadId: string, message: string): Promise<void> {
    await axios.post(`${API_BASE}/reply.php`, { threadId, message });
  },

  async action(threadId: string, action: 'accepted' | 'declined' | 'blocked'): Promise<void> {
    await axios.post(`${API_BASE}/action.php`, { threadId, action });
  },

  async shareContact(threadId: string): Promise<void> {
    await axios.post(`${API_BASE}/share-contact.php`, { threadId });
  },
};
